@if (logement$ | async; as logement) {
  <section class="container-background container-fluid content">
    <div class="row">
      <h2 class="page-title col-12">Mes équipements
        @if (logement?.isOpen()) {
          <button class="btn btn-blue btn-lg float-end" routerLink="ajouter">
            <fa-icon [icon]="faPlus"></fa-icon> Ajouter
          </button>
        }
      </h2>
    </div>
    <div class="m-2 p-4 bg-white rounded">
      <div class="mt-4">
        @if (filteredEquipements?.length > 0) {
          <div class="row">
            @for (carnetEquipement of filteredEquipements; track carnetEquipement) {
              <div class="col-sm-6 col-lg-4 col-xl-3 mb-4">
                <app-card [link]="'/equipement/' + carnetEquipement.equipement.id" [image]="(carnetEquipement.equipement.image.url | backResource)"
                  [title]="carnetEquipement.equipement.nom" [text]="carnetEquipement.equipement.description ? carnetEquipement.equipement.description : carnetEquipement.equipement.nom | excerpt">
                  <a ngbDropdownItem [routerLink]="'/equipement/' + carnetEquipement.equipement.id">Visualiser</a>
                  @if (logement?.isOpen() && carnetEquipement.equipement.type == EquipementType.INDIVIDUEL && equipementService.isAuthorizedToEdit(carnetEquipement)) {
                    <a ngbDropdownItem [routerLink]="'/mes-equipements/personnaliser/' + carnetEquipement.equipement.id">Personnaliser</a>
                    <app-delete-confirm (deleted)="delete(carnetEquipement)" [message]="'Confirmez-vous la suppression de cet équipement ?'">
                      <button ngbDropdownItem> Supprimer</button>
                    </app-delete-confirm>
                  }
                </app-card>
              </div>
            }
          </div>
        } @else {
          <div class="alert alert-info">Pour bien utiliser et entretenir les équipements de votre logement, ajoutez-les ici
            <br>
              @if (logement?.isOpen()) {
                <button class="btn btn-lg btn-orange" routerLink="ajouter">
                  Ajouter un équipement
                </button>
              }
            </div>
          }
        </div>
      </div>
    </section>
  }
